import { render, staticRenderFns } from "./CustomDocumentPreview.vue?vue&type=template&id=160b387a&scoped=true"
import script from "./CustomDocumentPreview.vue?vue&type=script&lang=js"
export * from "./CustomDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./CustomDocumentPreview.vue?vue&type=style&index=0&id=160b387a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b387a",
  null
  
)

export default component.exports